import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';

dayjs.extend(duration);

export const timeToStartStream = (stream) => {
    const eventTime = dayjs(stream.from_date).valueOf();
    const currentTime = dayjs().valueOf();

    const diffTime = eventTime - currentTime;
    let duration = dayjs.duration(diffTime, 'milliseconds');
    return +duration.asMinutes().toFixed(0);
};
